module.exports = __webpack_public_path__ + "img/image_03sp.0394fc9d.jpg";